class SearchModal extends HTMLElement {
	constructor() {
		super();

	    this.$modal = document.querySelector('.js-search-modal');
	    this.$close = document.querySelector('.js-search-modal-close');
	    this.$open = document.querySelector('.js-search-modal-open');
	    this.$close.addEventListener('click', this.close.bind(this));;
	    this.$open.addEventListener('click', this.open.bind(this));;
	    this.activeClass = 'js-search-modal-open';
	}

	close() {
		this.$modal.classList.remove(this.activeClass);
		document.querySelector('.header').classList.remove('search-open');	
	}

	open() {
		const boostPFS = document.querySelector('.boost-pfs-search-box');
		if( boostPFS ){
			boostPFS.focus();
		}else{
			document.querySelector('.header').classList.add('search-open');	
			this.$modal.classList.add(this.activeClass);				
		}

	}
}

customElements.define('search-modal', SearchModal);